import React, { useState } from "react";
import {
  faCheckCircle,
  faClose,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import SecureLS from "secure-ls";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MessageModal from "./MessageModal";
import { mutate } from "swr";
import useSWR from "swr";

const ls = new SecureLS({ encodingType: "aes" });

const AddVoucher = () => {
  const [clientFirstName, setClientFirstName] = useState("");
  const [clientLastName, setClientLastName] = useState("");
  const [clientContact, setClientContact] = useState("");
  const [loading, setLoading] = useState(false);
  const [clientDataState, setClientDataState] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [expiryDays, setExpiryDays] = useState("");
  const [isMessageModalVisibleAddRequest, setIsMessageModalVisibleAddRequest] =
    useState(false);
  const toggleModalClose = () => {
    setIsMessageModalVisibleAddRequest(false);
  };

  const username = ls.get("username");
  const userpw = ls.get("userpw");
  const usercsrf_token = ls.get("usercsrf_token");

  const fetcher = (url) =>
    fetch(url, {
      credentials: "include",
      mode: "cors",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Basic ${btoa(`${username}:${userpw}`)}`,
        "X-CSRF-Token": usercsrf_token,
      },
    })
      .then((res) => res.json())
      .then((data) => (Array.isArray(data) ? data : [data]));

  const {
    data: categories,
    error: categoriesError,
    isLoading: categoriesLoading,
  } = useSWR(
    `${process.env.REACT_APP_VOUCHER_TAXONOMY_CATEGORIES_TERM_API}?_format=json`,
    fetcher
  );

  console.log("taxonomy categories", categories);

  const handleAddVoucherSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (!username || !userpw || !usercsrf_token) {
        alert("Missing credentials. Please log in again.");
        setLoading(false);
        return;
      }

      if (!expiryDays) {
        alert("Please select an expiry period.");
        setLoading(false);
        return;
      }

      if (!selectedCategory) {
        alert("Please select a voucher category.");
        setLoading(false);
        return;
      }

      const generateVoucherPayload = {
        type: [{ target_id: "voucher" }],
        title: [{ value: "New Voucher" }],
        field_voucher_category: [{ target_id: selectedCategory }],
        field_expiry_days: [{ value: expiryDays }],
      };

      const requestresponse = await fetch(
        `${process.env.REACT_APP_SLASH_NODE_URL}?_format=json`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Basic ${btoa(`${username}:${userpw}`)}`,
            "X-CSRF-Token": usercsrf_token,
          },
          body: JSON.stringify(generateVoucherPayload),
        }
      );

      if (!requestresponse.ok) {
        const contentType = requestresponse.headers.get("content-type");
        const errorText = await requestresponse.text();

        if (contentType && contentType.includes("application/json")) {
          try {
            const errorJson = JSON.parse(errorText);
            alert(
              `Error creating voucher: ${errorJson.message || "Unknown error"}`
            );
          } catch {
            alert(`Error creating voucher: ${errorText}`);
          }
        } else {
          alert(`Error creating voucher: ${errorText}`);
        }

        setLoading(false);
        return;
      }

      const createdVoucher = await requestresponse.json();
      console.log("Generated Voucher:", createdVoucher);
      console.log("Generated Voucher NID:", createdVoucher.nid[0].value);

      // Add Client to Voucher
      try {
        const clientdataPayload = {
          type: [{ target_id: "client" }],
          title: [{ value: clientFirstName }],
          field_last_name: [{ value: clientLastName }],
          field_contact_number: [{ value: clientContact }],
          field_voucher_reference: [{ target_id: createdVoucher.nid[0].value }],
        };

        const response = await fetch(
          `${process.env.REACT_APP_SLASH_NODE_URL}?_format=json`,
          {
            method: "POST",
            headers: {
              Authorization: `Basic ${btoa(`${username}:${userpw}`)}`,
              "Content-Type": "application/json",
              "X-CSRF-Token": usercsrf_token,
            },
            body: JSON.stringify(clientdataPayload),
          }
        );

        const responseData = await response.json();
        setClientDataState(responseData);
        console.log("responseData?", responseData);

        if (!response.ok) {
          if (response.status === 500 && responseData.message) {
            throw new Error(responseData.message);
          } else if (responseData.message) {
            throw new Error(responseData.message);
          } else {
            throw new Error("Failed to submit client data");
          }
        }

        console.log("Client assigned to the voucher!");

        // Clear form fields
        setClientFirstName("");
        setClientLastName("");
        setClientContact("");
      } catch (error) {
        console.error("Error:", error);
        alert(error.message || "An error occurred while submitting the form");
      } finally {
        setLoading(false);
      }

      mutate(`${process.env.REACT_APP_VOUCHER_SCREENING_CONTENT_EDITOR_API}`);
      setIsMessageModalVisibleAddRequest(true);

      // Send SMS Voucher Code to generated voucher Start
      const sendSMStoClientForVoucher = async () => {
        const fetchSendSMSToClient = await fetch(
          `${process.env.REACT_APP_SMS_URL_API}`,
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              key: `${process.env.REACT_APP_SMS_KEY}`,
              msisdn: `${clientDataState?.field_contact_number?.[0]?.value}`,
              message: `Dear ${clientDataState?.title?.[0]?.value} ${clientDataState?.field_last_name?.[0]?.value}, your voucher code is: ${createdVoucher.field_voucher_code[0].value}. Kindly visit Islamic Specialist Clinic and Diagnostic Center to redeem your voucher and enjoy the free service. Thank you!`,
              sender_id: "IDC",
            }),
          }
        );
        if (!fetchSendSMSToClient.ok) {
          const error = await fetchSendSMSToClient.json();
          console.log("Failed to send SMS to new client:", error.message);
          return;
        }

        const fetchSendSMSToClientJson = await fetchSendSMSToClient.json();
        console.log("fetchSendSMSToClientJson", fetchSendSMSToClientJson);
      };
      sendSMStoClientForVoucher();

      // Send Voucher Code to generated voucher End
    } catch (error) {
      console.error("Fetch failed:", error);
      alert("Network Error: " + error.message);
      setLoading(false);
    }
  };

  return (
    <div className="add-ctscan-request-register">
      <form onSubmit={handleAddVoucherSubmit} className="patient-form">
        <div className="form-group">
          <label>Voucher Category:</label>
          {categoriesLoading ? (
            <p>Loading categories...</p>
          ) : categoriesError ? (
            <p>Error loading categories.</p>
          ) : (
            <select
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
              required
            >
              <option value="">-- Select a category --</option>
              {Array.isArray(categories) &&
                categories.map((cat) => (
                  <option key={cat.tid} value={cat.tid}>
                    {cat.name}
                  </option>
                ))}
            </select>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="expiryDays">Expiry Period (days)</label>
          <select
            id="expiryDays"
            value={expiryDays}
            onChange={(e) => setExpiryDays(Number(e.target.value))}
            required
          >
            <option value="">-- Select Expiry Period --</option>
            {Array.from({ length: 30 }, (_, i) => (
              <option key={i + 1} value={i + 1}>
                {i + 1} {i === 0 ? "day" : "days"}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="firstName">First Name</label>
          <input
            type="text"
            placeholder="Enter first name"
            value={clientFirstName}
            onChange={(e) => setClientFirstName(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="lastName">Last Name</label>
          <input
            type="text"
            placeholder="Enter last name"
            value={clientLastName}
            onChange={(e) => setClientLastName(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="contact">Contact Number</label>
          <input
            type="tel"
            placeholder="Enter contact number"
            value={clientContact}
            onChange={(e) => setClientContact(e.target.value)}
            required
          />
        </div>

        <div className="submitGroup">
          <button type="submit" disabled={loading}>
            {loading ? (
              <FontAwesomeIcon icon={faSpinner} spin fontSize={22} />
            ) : (
              "Generate Voucher"
            )}
          </button>
        </div>
      </form>

      {isMessageModalVisibleAddRequest && (
        <MessageModal
          leftIcon={faCheckCircle}
          color="green"
          fontSize={20}
          message="Voucher generated successfully!"
          onClose={toggleModalClose}
          rightIcon={faClose}
        />
      )}
    </div>
  );
};

export default AddVoucher;
